import { ApplicationWrapper, Loader } from 'ui/containers';

import RoutesApplication from './containers/ApplicationWrapper/RoutesApplication';
import { ProviderStargate } from './ProviderStargate';
import { GlobalStyles } from './theme';

function App({ isStargate = false, isSearch }: { isStargate?: boolean; isSearch?: boolean }) {
  return (
    <ProviderStargate isStargate={isStargate} isSearch={isSearch}>
      <ApplicationWrapper isStargate={isStargate} isSearch={isSearch}>
        <>
          <Loader />
          <GlobalStyles />
          <RoutesApplication />
        </>
      </ApplicationWrapper>
    </ProviderStargate>
  );
}

export default App;
